import { Skeleton } from '@platform/design-system';
import type { ReactNode } from 'react';
import { LoadFailed } from './LoadFailed.tsx';
import { usePageContext } from './usePageContext.ts';

type ViewedQuery<Data> = {
  readonly data: Data | undefined;
  readonly isError: boolean;
  readonly error: unknown;
  readonly refetch: () => unknown;
};

export type QueryViewProps<Data> = {
  query: ViewedQuery<Data>;
  label: string;
  height?: string;
  children: (data: Data) => ReactNode;
};

export const QueryView = <Data,>({ query, label, height = '420px', children }: QueryViewProps<Data>) => {
  const { describeError } = usePageContext();
  if (query.isError)
    return <LoadFailed description={describeError(query.error)} onRetry={() => void query.refetch()} />;
  if (query.data === undefined) return <Skeleton height={height} label={label} />;
  return <>{children(query.data)}</>;
};
